import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';

export function getAbGroupByExperimentName(experiments: IABExperiment[], experimentName: string): number | undefined {
  const experiment = experiments.find(({name}) => name === experimentName);

  return experiment && experiment.abGroup;
}

export const MICRODATA_EXPERIMENT_NAME = 'microdata_experiment';
export const MICRODATA_DOMAIN_EXPERIMENT_B = 'korolev';
export const MICRODATA_DOMAIN_EXPERIMENT_C = 'lyubertsy';

export enum MicrodataExperimentGroups {
  B = 1,
  C = 2,
}

export const MICRODATA_EXPERIMENT_ALL_GROUPS = [MicrodataExperimentGroups.B, MicrodataExperimentGroups.C];

export function getHittingMicrodataExperiments(subdomain: string): IABExperiment {
  let microdataExperiment: IABExperiment = {
    abGroup: 0,
    name: MICRODATA_EXPERIMENT_NAME,
  };

  if (subdomain === MICRODATA_DOMAIN_EXPERIMENT_B) {
    return Object.assign(microdataExperiment, {
      abGroup: MicrodataExperimentGroups.B,
    });
  }

  if (subdomain === MICRODATA_DOMAIN_EXPERIMENT_C) {
    return Object.assign(microdataExperiment, {
      abGroup: MicrodataExperimentGroups.C,
    });
  }

  return microdataExperiment;
}
